module.exports = __webpack_public_path__ + "static/billsby-briefing-a59de09e529276a52bb81523d10a1090.svg";